import type { MilliSeconds } from "../../vu-player-models/time/MilliSeconds";

export function delay(ms: MilliSeconds) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
